import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { logStopsFilter } from '../../../../../common/log-ga-event'
import { updateStopsFiltersReq } from '../../../../reducers/filters/filterInfo/filterInfo'
import { updateStopsFiltersUI } from '../../../../reducers/filters/stopsFilter/stopsFilter'

export const useStopsFilters = ({ changeHandler, isDynamic = false, isMobileView = false }) => {
  const dispatch = useDispatch()

  const { stops, activeTabId } = useSelector((state) => {
    return {
      stops: state?.stopsFilter || [],
      activeTabId: state?.activeTabId,
    }
  })

  const isPackageListings = useSelector((state) => state?.pclnBootstrapData?.isPackageListings)

  let stopsFilter = stops
  const showCountInLabel = isPackageListings || !isMobileView
  if (showCountInLabel) {
    stopsFilter = stops.map((stop) => ({
      ...stop,
      primaryLabel: stop.count ? `${stop.primaryLabel} (${stop.count})` : stop.primaryLabel,
    }))
  }

  const delayedStateUpdate = useCallback(
    (shouldFireChange = true) => {
      return (...args) => {
        const [payload, meta] = args
        dispatch(updateStopsFiltersReq({ payload, meta, sbsParams: { activeTabId } }))

        if (shouldFireChange && changeHandler) {
          changeHandler()
        }
      }
    },
    [dispatch, activeTabId, changeHandler]
  )

  const stopsHandleChange = useCallback(
    (changed, shouldFireChange = true, shouldLog = true) => {
      const filterItem = Object.keys(changed)[0]
      // Selecting a stop chip should clear the others so the request gets that max
      const meta = changed[filterItem] ? { isOnlyClick: true } : {}
      if (shouldLog) {
        logStopsFilter({ numStops: filterItem, isDynamic, enabled: changed[filterItem] })
      }
      dispatch(updateStopsFiltersUI({ payload: changed, meta }))
      delayedStateUpdate(shouldFireChange)(changed, meta)
    },
    [dispatch, delayedStateUpdate, isDynamic]
  )

  const resetClick = useCallback(
    ({ shouldFireChange = true } = {}) => {
      const changed = { 0: false, 1: false, 7: false }
      const shouldLog = false
      stopsHandleChange(changed, shouldFireChange, shouldLog)
    },
    [stopsHandleChange]
  )

  return {
    stops: stopsFilter,
    stopsHandleChange,
    resetClick,
  }
}
